const init = () => {
  document.querySelectorAll('.js-feature-tabs-wrapper').forEach(setupFeatureTabs);
}

const setupFeatureTabs = wrapper => {
  const allHeadings = wrapper.querySelectorAll('.js-feature-tab-heading');
  allHeadings.forEach(heading =>
    heading.addEventListener('click', event => changeTab(event, allHeadings, wrapper)));
}

const changeTab = (event, allHeadings, wrapper) => {
  let activeTabIndex;
  allHeadings.forEach((heading, i) => {
    if(event.currentTarget === heading) {
      activeTabIndex = i;
      heading.classList.add('is-active');
    } else {
      heading.classList.remove('is-active');
    }
  });

  const allBodies = wrapper.querySelectorAll('.js-feature-tab-body');
  allBodies.forEach(body => body.classList.add('is-hidden'));
  allBodies[activeTabIndex].classList.remove('is-hidden');

  const allImgs = wrapper.querySelectorAll('.js-feature-tab-img');
  allImgs.forEach(img => img.classList.add('is-hidden'));
  allImgs[activeTabIndex].classList.remove('is-hidden');
}

export default {init};
